"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var authentication_service_1 = require("../../service/authentication.service");
var router_1 = require("@angular/router");
var store_1 = require("@angular-redux/store");
var actions_1 = require("../../../core/actions");
var http_service_1 = require("../../service/http.service");
var http_request_builder_1 = require("../../../core/http-request-builder");
var TxNavBarComponent = /** @class */ (function () {
    function TxNavBarComponent(authenticationService, router, ngRedux, httpService, httpRequestBuilder) {
        var _this = this;
        this.authenticationService = authenticationService;
        this.router = router;
        this.ngRedux = ngRedux;
        this.httpService = httpService;
        this.httpRequestBuilder = httpRequestBuilder;
        this.totalRequests = 0;
        this.handleLoadingValue = function (value) {
            if (value) {
                _this.totalRequests++;
                _this.isLoading = true;
            }
            else {
                _this.totalRequests--;
                if (_this.totalRequests === 0) {
                    _this.isLoading = false;
                }
            }
        };
        this.user = this.authenticationService.getUserFromLocalStorage();
        this.setLoadingObserver();
    }
    TxNavBarComponent.prototype.ngOnInit = function () {
    };
    TxNavBarComponent.prototype.logout = function () {
        this.authenticationService.removeUser();
        this.router.navigate(['/login']);
        this.ngRedux.dispatch({ type: actions_1.CLEAN_STATE });
    };
    TxNavBarComponent.prototype.setLoadingObserver = function () {
        this.httpService.isLoading$
            .subscribe(this.handleLoadingValue);
        this.httpRequestBuilder.isLoading$
            .subscribe(this.handleLoadingValue);
    };
    TxNavBarComponent.ctorParameters = function () { return [{ type: authentication_service_1.AuthenticationService }, { type: router_1.Router }, { type: store_1.NgRedux }, { type: http_service_1.HttpService }, { type: http_request_builder_1.HttpRequestBuilder }]; };
    return TxNavBarComponent;
}());
exports.TxNavBarComponent = TxNavBarComponent;
//# sourceMappingURL=tx-nav-bar.component.js.map


// WEBPACK FOOTER //
// tx-nav-bar.component.js